import React from "react";
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import MyInput from '../../components/controls/MyInput';

class ConfirmPopupWithInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resetCode: ''
        };
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'resetCode' && value.length > 10)
            return;

        this.setState({ [name]: value.trim() });
    }

    validateFormData = () => {
        if (this.state.resetCode || this.state.resetCode.trim()) {
            this.props.onOk(this.state.resetCode);
        }
    }

    render() {
        return (
            <div className="p-2 deletePopup">
                <h3 className="mb-4 heading5"><Icon type="question-circle" className="mr-2 color-red" />{this.props.header}</h3>
                
                <div className="row flex-sm-row ">
                    <div className="mb-2 col-sm-12">
                        <label htmlFor="category">Enter Reset Code<span className="color-red">*</span></label>
                        <MyInput id="resetCode"
                            type="text"
                            key="resetCode"
                            name="resetCode"
                            value={this.state.resetCode}
                            onChange={this.onTextChange}
                            isRequired={true} />
                    </div>

                    <div className="pb-4 pt-2 col-sm-12 font-weight-bold">{this.props.message}</div>
                </div>
                <div className="d-flex m-auto deletePopup_buttons justify-content-center">
                    <button className="button-global button-border mr-3 autoHeight" type="primary mr-3"
                        onClick={this.props.onCancel}>{this.props.noButtonText? this.props.noButtonText : 'No'}</button>
                    <button className="button-global button-primary m-0 autoHeight" disabled={!this.state.resetCode} type="primary"
                        onClick={this.validateFormData}>{this.props.yesButtonText? this.props.yesButtonText : 'Yes'}</button>
                </div>
            </div>
        );
    }
}

ConfirmPopupWithInput.propTypes = {
    onCancel: PropTypes.func,
    onDelete: PropTypes.func,
    message: PropTypes.string.isRequired,
    onOk: PropTypes.func
};

export default ConfirmPopupWithInput;